import ComicList from './ComicList.js';
import './App.css';

function App() {
  return (
    <div className="App">
        <ComicList />
    </div>
  );
}

export default App;
